import { forwardRef } from 'react'

import classNames from 'classnames'

import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dialog } from '@headlessui/react'
import { Trans } from '@lingui/macro'
import Button from 'Root/App/Button'
import PanelLayout from 'Root/App/Dialog/PanelLayout'
import Chip from 'Root/App/Item/Chip'
import Icon from 'Root/App/Item/icon'
import Paragraph from 'Root/App/Paragraph'
import Title from 'Root/App/Title'

interface RemoveUserAuthorizationAlertProps {
  onClose: () => void
  onConfirm: () => void
  isRemoving: boolean
}

type Ref = HTMLDivElement

const RemoveUserAuthorizationAlert = forwardRef<
  Ref,
  RemoveUserAuthorizationAlertProps
>(function RemoveUserAuthorizationAlert(
  { onClose, onConfirm, isRemoving },
  ref
) {
  const callToActionButtons = (
    <Button
      className={classNames([
        'flex justify-center items-center px-4 py-2 gap-1 flex-grow rounded-lg bg-gray-900',
        { 'animate-pulse': isRemoving },
      ])}
      onClick={onConfirm}
      disabled={isRemoving}
    >
      <Title size="2XS" className="text-white">
        <Trans>Conferma</Trans>
      </Title>
    </Button>
  )

  return (
    <Dialog.Panel
      className="relative flex flex-col pb-6 pt-5 px-6 bg-white rounded-t-3xl shadow-lg2 sm:pb-8 sm:pt-8 sm:px-8 sm:w-auto sm:h-auto sm:rounded-3xl"
      ref={ref}
    >
      <PanelLayout
        title={<Trans>Rimuovi permesso</Trans>}
        cta={callToActionButtons}
        onClose={onClose}
      >
        <Chip
          highlight
          highlightCustomClass="flex flex-col gap-3 bg-white"
          icon={
            <Icon bgColor="bg-brand-accent1">
              <FontAwesomeIcon
                className="text-gray-900 w-5 h-5 text-sm font-black"
                icon={faTriangleExclamation}
              />
            </Icon>
          }
        >
          <span className="flex flex-col items-start gap-1 self-stretch bg-white">
            <Title size="XS">
              <Trans>Sei Sicuro?</Trans>
            </Title>
            <Paragraph className="sm:max-w-sm sm:w-auto">
              <Trans>
                Stai per rimuovere il permesso di accesso per questo elemento.
              </Trans>
            </Paragraph>
          </span>
        </Chip>
      </PanelLayout>
    </Dialog.Panel>
  )
})

export default RemoveUserAuthorizationAlert
